import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"

import { useUserSettingsSite, useUserSettingsSiteValidator } from "../../../@hooks"


export default function UserSettingSiteDrawerSubmit() {
	const { isLoading, handleSubmitSitesFormData } = useUserSettingsSite()
	const { isValid } = useUserSettingsSiteValidator()

	return <ButtonLoadingSeeker
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitSitesFormData}
	>
		Save
	</ButtonLoadingSeeker>
}